import React, { createContext, useContext } from 'react';
import { LinkVM, NavigationItem } from '../types/ee-header';

interface HeaderContextValue {
  items?: LinkVM[];
  businessSegmentTitle?: string;
  businessSegmentLinkUrl?: string;
  personalSegmentTitle?: string;
  personalSegmentLinkUrl?: string;
  nav?: Record<string, NavigationItem>;
  logInLinkUrl?: string;
  logInLinkTitle?: string;
  businessSegmentLargeBusinessButtonLabel?: string;
  businessSegmentLargeBusinessLinkUrl?: string;
  businessSegmentLargeBusinessMessage?: string;
  businessSegmentLargeBusinessTitle?: string;
  businessSegmentMainMessage?: string;
  businessSegmentSmallBusinessButtonLabel?: string;
  businessSegmentSmallBusinessLinkUrl?: string;
  businessSegmentSmallBusinessMessage?: string;
  businessSegmentSmallBusinessTitle?: string;
}

const HeaderContext = createContext<HeaderContextValue | null>(null);

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within HeaderProvider');
  }
  return context;
};

export const HeaderProvider: React.FC<{
  children: React.ReactNode;
  value: HeaderContextValue;
}> = ({ children, value }) => (
  <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
);
